import {Link} from "react-router-dom";
import './Footer.css';

export default function Footer () {
    return (
            <footer className="footer_menu"> 
              <div>© MLG</div>    
              <div>Tous droits réservés - 2023</div>
              <Link to="/contact">Contact</Link> 
            </footer>
    );
}